import { Injectable } from '@angular/core';
import { QueryParameters } from '../../../reporting/analytics-core/interfaces/query-parameters.interface';
import { KEYS } from '../constants/storage.constants';
import { StorageCookieService } from './storage.cookie.service';
import { StorageLocalService } from './storage.local.service';

@Injectable()
export class StorageSessionService {
	private _hasSession = false;
	private _token = '';
	private _queryParams = '';
	private _URLproductRoute = '/dashboard';
	private _reloadDataAfterLogin: boolean = false;

	constructor(private storageLocalService: StorageLocalService, private storageCookieService: StorageCookieService) {}

	get token(): string {
		return this._token;
	}

	set token(value: string) {
		this._token = value;
	}

	get hasSession(): boolean {
		return this._hasSession;
	}

	set hasSession(value: boolean) {
		this._hasSession = value;
	}

	get queryParams(): string {
		return this._queryParams;
	}

	set queryParams(value: string) {
		this._queryParams = value;
	}

	get URLproductRoute(): string {
		return this._URLproductRoute;
	}

	set URLproductRoute(value: string) {
		this._URLproductRoute = value;
	}

	get reloadDataAfterLogin(): boolean {
		return this._reloadDataAfterLogin;
	}

	set reloadDataAfterLogin(value: boolean) {
		this._reloadDataAfterLogin = value;
	}

	checkSession(): void {
		if (this.getToken(KEYS.STORAGE_TOKEN_ID)) {
			const token: any = this.processToken(this.getToken(KEYS.STORAGE_TOKEN_ID));
			if (token !== '') {
				this.hasSession = true;
				this.token = token;
			}
		}
	}

	processToken(tokenObject: any): any {
		let token = '';
		if (this.storageLocalService.isLocalStorageEnabled()) {
			const expiryTimeStamp = tokenObject[KEYS.EXPIRE_TOKEN];
			if (this.getTimeStamp() >= expiryTimeStamp) {
				this.storageLocalService.deleteStorageItem(KEYS.STORAGE_TOKEN_ID);
			} else {
				token = tokenObject[KEYS.COOKIE_TOKEN_ID];
			}
		} else if (this.storageCookieService.isCookieEnabled()) {
			token = tokenObject;
		}
		return token;
	}

	getTimeStamp(date?: any): any {
		if (date) {
			return new Date(date).getTime();
		}
		return new Date().getTime();
	}

	setToken(storageTokenId: any, cookieTokenId: any, token: any, expiry: any): void {
		this.setDataToLocalStorage(storageTokenId, cookieTokenId, token, expiry);
	}

	setServiceURL(storageTokenId: any, cookieTokenId: any, token: any, expiry: any): void {
		this.setDataToLocalStorage(storageTokenId, cookieTokenId, token, expiry);
	}

	setDataToLocalStorage(storageTokenId: any, cookieTokenId: any, token: any, expiry: any): void {
		this.reloadDataAfterLogin = true;
		if (this.storageLocalService.isLocalStorageEnabled()) {
			this.storageLocalService.setStorageItem(storageTokenId, cookieTokenId, token, expiry);
		} else if (this.storageCookieService.isCookieEnabled()) {
			this.storageCookieService.setCookie(cookieTokenId, token, expiry);
		} else {
			console.error('Local Storage and Cookies Disabled');
		}
	}
	getToken(tokenId: any): any {
		return this.getDataFromLocalStorage(tokenId);
	}

	getServiceURL(tokenId: any): any {
		return this.getDataFromLocalStorage(tokenId);
	}

	getDataFromLocalStorage(tokenId: any): any {
		if (this.storageLocalService.isLocalStorageEnabled()) {
			return this.storageLocalService.getStorageItem(tokenId);
		} else if (this.storageCookieService.isCookieEnabled()) {
			return this.storageCookieService.getCookie(tokenId);
		} else {
			console.error('Local Storage and Cookies Disabled');
			return;
		}
	}

	clearToken(tokenId?: any): void {
		this.storageLocalService.deleteStorageItem(!tokenId ? KEYS.STORAGE_TOKEN_ID : tokenId);
		this.storageCookieService.deleteCookie(!tokenId ? KEYS.COOKIE_TOKEN_ID : tokenId);
	}

	clearServiceURL(tokenId?: any): void {
		this.storageLocalService.deleteStorageItem(!tokenId ? KEYS.STORAGE_SERVICE_URL_ID : tokenId);
		this.storageCookieService.deleteCookie(!tokenId ? KEYS.COOKIE_SERVICE_URL : tokenId);
	}

	getQueryParamsObj(): QueryParameters {
		const queryParamsObj: QueryParameters = {};
		if (this.queryParams !== '') {
			const queryParamsString = this.queryParams.split('?')[1];
			const queryParamsProperties = queryParamsString.split('&');
			queryParamsProperties.forEach((obj) => {
				const objURLValues = obj.split('=');
				queryParamsObj[objURLValues[0]] = objURLValues[1];
			});
		}
		return queryParamsObj;
	}
}
